import React, {useState} from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const PaymentButton = (props: any) => {
	const {t, checkForStatus, delictId} = props;
	const [showButton, setShowButton] = useState(true);
	const [processingPayment, setProcessingPayment] = useState(false);

	const toggleButtonVisibility = (status: number) => {
		switch (status) {
				case 201:
						setProcessingPayment(false);
						break;
				case 500:
						return false;
				case 200:
						setProcessingPayment(true);
						break;
				case 400:
						setShowButton(true);
						setProcessingPayment(false);
						break;
				default:
						return false;
		}
	}

	return (
		<>
			{showButton &&
				<Link to={`/form/${delictId}`} target={"_blank"}>
					<Button onClick={() => {
						setShowButton(false);
						setProcessingPayment(true);

						const checkInterval = setInterval(() => {
							checkForStatus(delictId)
								.then((status: any) => {
									toggleButtonVisibility(status);

									if (status === 201 || status === 400) {
										clearInterval(checkInterval);
									}
								}).catch((error: any) => {
									console.log(error);
								});
						}, 5000);
						}} className="btn btn-success btn-xs">{t('Плати')}
					</Button>
				</Link>
			}

			{processingPayment && <span className={'cell--status paid waiting'}>{t('waiting.payment.confirmation')}</span>}
		</>
	)
}

export default PaymentButton;